export default __webpack_public_path__ + "book_details-reading_age.3f66b5ac.png";